export default __webpack_public_path__ + "static/media/GU.70360be9.svg";